const getSearchParam = (param: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
};

const setSearchParam = (param: string, value: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(param, value);
};

const removeParamUrl = (param: string) => {
  const search = window.location.search;
  var searchParams = new URLSearchParams(search);
  searchParams.delete(param);
  return searchParams.toString();
};

export { getSearchParam, setSearchParam, removeParamUrl };
